<template>
  <div>
    <validation-observer :ref="`${code}-validator`">
      <SectionTitle
        content="VI. Otras recomendaciones (o estrategias adicionales relativas a la AT)"
        :has-line="true"
      />
      <div class="d-flex justify-content-end" style="margin-bottom: 20px;">
        <action-button
          v-if="!isReadOnly"
          variant="success"
          @click="addComment"
          type="button"
          style="margin-top: 10px; padding: 10px; background-color: #2DB782; color: #fff; border: none; border-radius: 5px; cursor: pointer;"
        >
          <i class="fas fa-file-plus" style="margin-right: 5px;"></i>
          Añadir Recomendacion
        </action-button>
      </div>
      <div v-for="(item, index) in value.comments" :key="index">
        <comment-display
          :value="item"
          @remove-comment="onDeleteClicked(item, index)"
          :isReadOnly="isReadOnly"
          :showRemoveButton="index !== 0 || value.comments.length > 1"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomTextArea from '@quisit/custom-text-area';
import CommentDisplay from './components/CommentDisplay.vue';
import Alerts from '@/mixins/alert.mixin';
import ActionButton from 'ActionButton';
import referralService from '@/services/api/referralsandequipments.api';
import TABS from '@/utils/constants/evaluationTabs';
import referralsandequipmentsApi from '@/services/api/referralsandequipments.api';

export default {
  name: 'Tab-VI',
  mixins: [Alerts],
  components: {
    SectionTitle,
    CustomTextArea,
    CommentDisplay,
    ActionButton,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    code: {
      type: String,
      default: () => '',
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      newComment: '',
      value: {
        comments: [],
      },
    };
  },
  computed: {
    showRemoveButton() {
      return this.value.comments.length > 1;
    },
  },
  async mounted() {
    await this.initData();
  },
  methods: {
    async initData() {
      await this.getInfo();
      if (this.value.comments.length === 0) {
        this.addComment();
      }
      this.$emit('loaded', TABS.VI);
    },
    async onDeleteClicked(item, index) {
      if (!item.comment) {
        this.removeComment(index);
      } else {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea remover el comentario agregado?`,
          'Sí',
          'No'
        );
        if (isConfirmed) {
          this.removeComment(index);
        }
      }
    },
    async getInfo() {
      try {
        const response = await referralsandequipmentsApi.getOtherRecommendationsComments(
          this.referralId
        );
        this.value.comments = response.data.map((c) => {
          return { comment: c };
        });
      } catch (error) {
        this.ShowToast(
          'Error',
          'Failed to fetch other recommendations comments',
          'error'
        );
      }
    },
    async addComment() {
      this.value.comments.push({ comment: null });
    },
    removeComment(index) {
      this.value.comments.splice(index, 1);
    },
    async validate() {
      const valid = await this.$refs[`${this.code}-validator`].validate();
      return {
        valid,
        message: valid
          ? ''
          : 'Otras recomendaciones (o estrategias adicionales relativas a la AT)',
      };
    },
    async save(showMessage = true) {
      referralService
        .saveOtherRecommendations(
          this.referralId,
          this.value.comments.map((item) => item.comment)
        )
        .then(async () => {
          if (showMessage) {
            this.ShowToast(
              'Éxito',
              'Información ha sido guardada exitosamente.',
              'success'
            );
          }
        })
        .catch((error) => {
          this.ShowToast('Alerta', error?.response?.data.message, 'error');
        });
    },
  },
};
</script>

<style lang="scss">
.panel-container {
  background-color: #f0f0f0;
  padding: 20px;
  border-radius: 10px;
}

.comment-box-panel {
  background-color: #ffffff;
  padding: 15px;
  margin-top: 10px;
  border-radius: 8px;
}
</style>
